module.exports = __webpack_public_path__ + "static/media/broken-clouds.dc2695a4.png";